// utils/modalManager.js
import { createRoot } from 'react-dom/client';
import SecureModal from '../components/modal/SecureModal';
// import SecureModal from '../components/SecureModal';

export const showSecureModal = ({ title, message, onClose }) => {
  // Create a div for our modal
  const modalRoot = document.createElement('div');
  modalRoot.id = 'secure-modal-root';
  document.body.appendChild(modalRoot);
  
  // Create a root and render the modal
  const root = createRoot(modalRoot);
  
  const handleClose = () => {
    // Clean up the modal
    root.unmount();
    document.body.removeChild(modalRoot);
    
    // Call the provided onClose handler
    if (onClose) onClose();
  };
  
  root.render(
    // <SecureModal
    //   isOpen={true}
    //   onClose={handleClose}
    //   title={title}
    //   message={message}
    // />
  );
};